import range from 'lodash/range';
import reverse from 'lodash/reverse';

import http from '../../../../../../../../shared/http';
import endpoints from '../../../../../../../../../config/endpoints';

export function numberToStringOption(number) {
	const string = number > 9 ? `${number}` : `0${number}`;
	return { value: string, label: string };
}

export const days = range(1, 32).map(numberToStringOption);

export const months = range(1, 13).map(numberToStringOption);

export const years = reverse(range(1900, 2013)).map((year) => ({
	value: year.toString(),
	label: year.toString()
}));

const CITIES_FETCH_DATA_SUCCESS = 'popups/cities-fetch-data-success';
const CITIES_FETCH_DATA_ERROR = 'popups/cities-fetch-data-error';

export function lookupCities(search, callback) {
	return dispatch => {
		const request = http({
			url: endpoints.LOOKUPS.CITIES,
			method: 'get',
			data: { query: search },
			actions: [CITIES_FETCH_DATA_SUCCESS, CITIES_FETCH_DATA_ERROR]
		});

		request(dispatch).then((action) => {
			if (action.type === CITIES_FETCH_DATA_SUCCESS) {
				callback(null, {
					options: action.payload.data.map((city) => ({
						value: city.id,
						label: city.text
					}))
				});
			} else {
				callback(null);
			}
		});
	};
}


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/render-custom-popup/custom-popups/birthday-and-city-popup/options.js